







































import Vue from 'vue'
import Component from 'vue-class-component'
import CategoryDetailsHeader from './header/CategoryDetailsHeader.vue'
import GridFilter from '@/components/grids/categoryDetails/filter/GridFilter.vue'
import { StoreActionTypes } from '@/store/types'
import GridComponent from '@/components/grids/categoryDetails/list/GridComponent.vue'
import ActionButton from '@/components/lib/button/ActionButton.vue'
import ModalComponent from '@/components/modal/ModalComponent.vue'
import {CategoryModel} from '@/services/types'
import { CreateCriterionRequestModel } from '@/services/types'
import CreateCriterionModalForm from '@/components/form/CreateCriterionModalForm.vue'

const CategoryDetailsProps = Vue.extend({
	props: {
		categoryId: {
			type: String,
			required: true,
			validator: function(value) {
				return Number.isInteger(parseInt(value))
			}
		}
		
	}
})

@Component({
	components: {
		CategoryDetailsHeader,
		GridFilter,
		GridComponent,
		ActionButton,
		ModalComponent,
		CreateCriterionModalForm
	}
})
export default class CategoryDetails extends CategoryDetailsProps {
	private componentClass = "CategoryDetails"
	private showCreateNewCriterionForm = false 

	mounted(){
		this.$store.dispatch(StoreActionTypes.SET_CATEGORIES_SELECTED_CATEGORY_WITH_CRITERIONS_LIST, this.categoryId)
	}

    handleCreateNewCriterionBtnClick() {
        this.showCreateNewCriterionForm = !this.showCreateNewCriterionForm
    }

    async handleCreateNewCriterionModalOkBtnClick() {
        const model: CreateCriterionRequestModel = (this.$refs.createNewCriterionModalForm as CreateCriterionModalForm).getCreateCriterionRequestModel()
		await this.$store.dispatch(StoreActionTypes.SET_CRITERIONS_CRITERION_CREATE, model)
		await this.$store.dispatch(StoreActionTypes.SET_CRITERIONS_LIST_BY_CATEGORY_ID)
        this.handleCreateNewCriterionBtnClick()
    }

	get createNewCriterionFormDisabled (){
        return this.$store.getters.isCriterionsDataLoading
    }

	get loadData(): boolean {
		return (this.$store.getters.getCategoriesSelectedCategory as CategoryModel) == null
	}
}
